export default function variantCodeUrlFormat(value: string | any) {
    if(value?.toUpperCase()?.includes("PREBOOK")){
        return value;
    }else{
        return value.substring(0, (value.length - 1)) + "/" + value.substring(value.length-1, value.length);
    }
}
